import {
    Button,
    GlanceLoader,
    Alert,
  } from '../ui-components';
  import React from 'react';

function InSessionState({onEndSession, gicon}) {

    return (
        <div className='SizeWrapper'>
            <div className='buttonAndTextWrapper'>
                <div className='rowAlign'>
                    { gicon && <div className='Spinner'>
                        <GlanceLoader size="12" spinning={false}></GlanceLoader>
                      </div> }
                    <span className="wrapper" style={{ display: "inline-block" }}>
                    
                    <Button size="small" variant="error" shape="rounded-full" animation="false" onClick={()=>(typeof(onEndSession) === typeof(Function)) ? onEndSession() : console.log("ES pressed")}>End session</Button>
                    
                    </span>
                </div>
                <div className='AlertWrapper'>
                    <Alert size="small" severity="success" variant="open" heading="Connected with visitor" closable="false" /> 
                </div>
            </div>  
        </div>
        
        
    );
}

export default InSessionState;